import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl, getAccess } from 'src/globals';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata'; 
import { cashup_returndata } from 'src/types/cashup_returndata';
import { GlobalService } from '../_services/global.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-cashuplist',
  templateUrl: './cashuplist.component.html',
  styleUrls: ['./cashuplist.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CashuplistComponent implements OnInit {
  ListCashup: any;
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledClass: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any;

  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;


  constructor(
    private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 

    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        if(getAccess("CASHUP", user)){
          this.AccessAllowed = true;
          this.loadgrid(false);
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });

  }
  
  loadgrid(showdisabled: boolean)
  {
    this.http.get(bmxurl + "cashuplist/" + this.VenueID).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ListCashup = (response as cashup_returndata);
      }
      else
      {
        this.messageService.add({severity:'error', summary:'Not Saved', detail:'Error getting Cash-ups, error: ' + this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Cash-ups, error: ' + error.messages});
    });
  }

  editData(EditData)
  {
    let CashupID = EditData;
    this.router.navigateByUrl("/cashup/" + CashupID);
  }

  
  }
